import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { StepList } from 'components/StepList/StepList';
import type { RootState } from 'reducers/types';
import { getCurrentStepIndex, getPaymentSteps, isEmbedded } from 'selectors';

type PropsFromRedux = ConnectedProps<typeof connector>;

const PaymentStepListComponent = ({
  activeStepIndex,
  steps,
  isEmbedded,
}: PropsFromRedux) => {
  if (isEmbedded) {
    return null;
  }

  return (
    <StepList activeStepIndex={activeStepIndex} totalSteps={steps.length} />
  );
};

const mapStateToProps = (state: RootState) => ({
  activeStepIndex: getCurrentStepIndex(state),
  isEmbedded: isEmbedded(state),
  steps: getPaymentSteps(state),
});

const connector = connect(mapStateToProps);
const PaymentStepList = connector(PaymentStepListComponent);

export { PaymentStepList };
